import { format, getDaysInMonth, subMonths } from 'date-fns';

export const monthKey = (date: Date) => format(date, 'yyyy-MM');

export const monthLabel = (month: string) => format(new Date(`${month}-01T00:00:00`), 'MMMM yyyy');

export const buildMonthOptions = (count = 12): string[] => {
  return Array.from({ length: count }, (_, index) => monthKey(subMonths(new Date(), index))).filter(
    (value, index, list) => list.indexOf(value) === index
  );
};

export const getDaysForMonth = (month: string): number[] => {
  const base = new Date(`${month}-01T00:00:00`);
  return Array.from({ length: getDaysInMonth(base) }, (_, index) => index + 1);
};
